import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { RadioButton } from '@naf-simba/elements-radio-button';

export const RadioButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.space8};
  margin-top: ${spacing.space24};
`;

export const StyledRadioButton = styled(RadioButton)``;
